
export const styles = {
  container: {
    backgroundColor: 'bg-gray-800',
    background: 'bg-gradient-to-b from-gray-900 to-gray-800',
    border: 'border border-blue-500/30',
    shadow: 'shadow-2xl shadow-blue-500/20',
    position: 'relative',
    overflow: 'hidden'
  },
  header: {
    background: 'bg-gray-900',
    backdropFilter: 'backdrop-blur-md',
    textColor: 'text-gray-100',
    border: 'border-b border-blue-500/30',
    animation: 'dark-header-appear 0.5s ease-out'
  },
  avatar: {
    background: 'bg-gray-800/80',
    text: 'text-blue-500',
    border: 'border border-blue-500/50',
    animation: 'dark-avatar-spin 10s linear infinite',
    glow: 'shadow-lg shadow-blue-500/50',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'bg-white/60',
      backdropFilter: 'backdrop-blur-md',
      text: 'text-gray-100',
      shadow: 'shadow-lg shadow-blue-500/20',
      border: 'border border-blue-500/30',
      animation: 'dark-message-appear 0.5s ease-out'
    },
    user: {
      background: 'bg-blue-500/20',
      backdropFilter: 'backdrop-blur-md',
      text: 'text-gray-100',
      shadow: 'shadow-lg shadow-blue-500/20',
      border: 'border border-blue-500/30',
      animation: 'dark-message-appear 0.5s ease-out'
    }
  },
  typingIndicator: {
    background: 'bg-gray-800/60',
    backdropFilter: 'backdrop-blur-sm',
    dot: 'bg-blue-500',
    border: 'border border-blue-500/30',
    animation: 'dark-typing-bounce 1.4s infinite'
  }
};